import React, {useCallback, useEffect, useState} from "react";
import axios from "axios";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import {useRef} from "react";
import MiniProduct from "./MiniProduct";
import {Box, Link} from "@mui/material";
import {makeStyles} from "@mui/styles";
import common from "../../utils/common";
import Analytics from "../../libs/analytics";

const useStyles = makeStyles((theme) => {

    return {
        merchandisedProduct: {
            padding: '16px',
            flexGrow: 1,
            overflowY: 'hidden',
            '-ms-overflow-style': 'none',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        merchandisedProductTitle: {
            display: '-webkit-box',
            '-webkit-box-orient': 'vertical',
            '-webkit-line-clamp': '1',
            overflow: 'hidden',
            color: '#2B2B2B',
            textAlign: 'center',
            fontSize: '20.52px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
            paddingTop: '8px'
        },
        merchandisedProductPrice: {
            color: '#2B2B2B',
            textAlign: 'center',
            fontSize: '16.416px',
            fontStyle: 'normal',
            fontWeight: '300',
            lineHeight: 'normal',
            paddingBottom: '10px'
        },
        merchandisedProductImage: {
            position: 'relative',
            aspectRatio: '16/9',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            border: '2px solid transparent',
            overflow: 'hidden',
            '@supports not(aspect-ratio)': {
                paddingTop: '56.25%',
            },
        },
        merchandisedProductCount: {
            minHeight: '27px',
            color: '#49454F',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
            textAlign: 'center',
            paddingTop: '8px'
        },
        merchandisedProductDescription: {
            paddingTop: '11px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '50%',
            [theme.breakpoints.down('sm')]: {
                height: '38%'
            }
        },
        merchandisedProductDescriptionTitle: {
            color: '#2B2B2B',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal'
        },
        merchandisedProductDescriptionBody: {
            overflow: 'auto',
            flexGrow: 1,
            paddingTop: '10px',
            color: '#2B2B2B',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '300',
            lineHeight: '23px'
        },
        textAction: {
            marginTop: "10px",
            color: '#2B2B2B',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '23px',
            cursor: 'pointer',
            '&:hover': {
                textDecoration: "underline"
            }
        },
        ctaWrapper: {
            boxShadow: '0px -4px 4px 0px rgba(176, 176, 176, 0.15)',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '16px',
            paddingBottom: '16px'
        },
        ctaButton: {
            display: 'flex',
            height: '38px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            flex: '1 0 0',
            color: '#ffffff  !important',
            backgroundColor: "#000",
            textDecoration: 'unset',
            textAlign: 'center',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '20px',
            letterSpacing: '1px',
            "&:hover, &:active": {
                color: '#ffffff',
                textDecoration: 'none'
            }

        },
        poweredBy: {
            marginTop: '11px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        poweredByName: {
            marginLeft: '4px',
            color: '#333',
            fontFamily: 'Arial',
            fontSize: '10px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
        },
        arrows: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '&:after': {
                display: 'none'
            },
            '&.swiper-button-disabled.swiper-button-lock': {
                display: 'none'
            }
        },
        fade: {},
        miniCard: {
            display: 'none',
            [theme.breakpoints.down('sm')]: {
                zIndex: '1100',
                position: 'absolute',
                bottom: '0',
                left: '16px',
                width: 'calc(100% - 32px)',
                minHeight: '40px',
                animationName: '$showMiniProductCard',
                animationDuration: '0.8s',
                animationIterationCount: '1',
                animationFillMode: 'forwards',
                backgroundColor: 'rgba(63, 63, 63, 0.50)'
            }
        },
        fullCard: {
            display: 'block',
            aspectRatio: '9/16',
            width: '100%',
            '@supports not(aspect-ratio)': {
                //paddingTop: '177.77%'
            },
            [theme.breakpoints.down('sm')]: {
                aspectRatio: '9/14',
                height: '80% !important',
                borderTopRightRadius: '28px',
                borderTopLeftRadius: '28px',
                '@supports not(aspect-ratio)': {
                    position: '155.55%',
                },
                '&$openDetails': {
                    display: 'block',
                    zIndex: '1100',
                    position: 'fixed',
                    bottom: '0',
                    animationName: '$showMiniProductCard',
                    animationDuration: '0.8s',
                    animationIterationCount: '1',
                    animationFillMode: 'forwards',
                    '& $merchandisedProduct': {
                        maxHeight: '441px'
                    }
                }
            }
        },
        openDetails: {
            maxWidth: '100%'
        },
        shapeMobile: {
            display: 'none',
            justifyContent: 'center',
            paddingTop: '8px',
            '& div': {
                width: '32px',
                height: '4px',
                flexShrink: 0,
                cursor: "pointer",
                backgroundColor: '#79747E',
                borderRadius: '100px'
            }
        },
        [theme.breakpoints.down('sm')]: {
            fullCard: {
                display: 'none',
            },
            miniCard: {
                display: 'block'
            },
            shapeMobile: {
                display: 'flex'
            }
        },
        mainWrapper: {},

        '@keyframes fadeInCTA': {
            '0%': {opacity: 0},
            '100%': {opacity: 1}
        },
        '@keyframes showMiniProductCard': {
            '0%': {
                '-webkit-transform': 'translateY(100%)',
                '-ms-transform': 'translateY(100%)',
                transform: 'translateY(100%)',
                opacity: 0
            },
            '75%': {
                '-webkit-transform': 'translateY(100%)',
                '-ms-transform': 'translateY(100%)',
                transform: 'translateY(100%)',
                opacity: 0,
            },
            '100%': {
                'webkit-transform': 'translateY(0)',
                '-ms-transform': 'translateY(0)',
                'transform': 'translateY(0)',
                '-webkit-animation-timing-function': 'cubic-bezier(0.48,0,0,1)',
                'animation-timing-function': 'cubic-bezier(0.48,0,0,1)',
                opacity: 1,
            }
        }
    }

});
const ProductItem = ({item, index, total = 0, currencySymbol = "$", userId, entityId}) => {
    const {title, description, product_id} = item;
    const safeLink = item.link || item.linkUrl;
    const imageUrl = item.image || item.imageUrl || item.image_url;

    const classes = useStyles();
    return <div key={product_id} data-testId={"products-swiper-item"} style={{
        minWidth: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        height: '100%'
    }}>
        <div className={classes.merchandisedProduct}>
            <Box height={'100%'}>
                <div className={classes.merchandisedProductTitle + " carousel-product-title"}>
                    <span>{title}</span>
                </div>
                <div className={classes.merchandisedProductPrice + " carousel-product-price"} style={{minHeight: '16px'}}>
                    {/*{price && <span>{currencySymbol}{price}</span>}*/}
                </div>
                <div className={classes.merchandisedProductImage + " carousel-product-image"}>
                    <img src={imageUrl} alt={title}
                         style={{position: 'absolute', top: 0, height: '100%'}}/>
                </div>
                <div className={classes.merchandisedProductCount}> {((total > 1) ? index + "/" + total : "")} </div>
                <div className={classes.merchandisedProductDescription}>
                    <div className={classes.merchandisedProductDescriptionTitle}>
                        Description:
                    </div>

                    <div className={classes.merchandisedProductDescriptionBody}>
                        {description}
                    </div>
                </div>
            </Box>

        </div>
        <div className={classes.ctaWrapper}>
            <Link onClick={() => Analytics.productClick({...item, id: product_id}, entityId)}
                underline={'none'} data-testId={"products-swiper-item-link"} target={"_blank"} role={'button'}
                className={classes.ctaButton} href={common.addSharedIdToUrl(safeLink, userId, product_id)}>
                Shop Now
            </Link>
            <div className={classes.poweredBy}>
                <Box display={'flex'} alignItems={'center'}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M11 5.50002C11 8.53756 8.53756 11 5.50002 11C2.46243 11 0 8.53756 0 5.50002C0 2.46243 2.46243 0 5.50002 0C8.53756 0 11 2.46243 11 5.50002ZM7.57336 4.55557H9.44497C9.01937 2.77125 7.4146 1.44445 5.49994 1.44445C3.26012 1.44445 1.44439 3.26018 1.44439 5.50002C1.44439 7.73982 3.26012 9.55557 5.49994 9.55557C7.4146 9.55557 9.01937 8.22876 9.44493 6.44447H7.57336C7.21447 7.23108 6.42107 7.77779 5.49998 7.77779C4.24201 7.77779 3.22222 6.75799 3.22222 5.50002C3.22222 4.24201 4.24201 3.22223 5.49998 3.22223C6.42107 3.22223 7.21447 3.76894 7.57336 4.55557Z"
                              fill="#DC2185"/>
                    </svg>
                </Box>
                <div className={classes.poweredByName}>
                    Powered by Creatable
                </div>
            </div>
        </div>
    </div>
}
const Products = ({entityId, clientId, userId, matchedProducts}) => {
    const [height, setHeight] = useState("auto")
    const [products, setProducts] = useState([]);
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);
    const [swiperInstance, setSwiperInstance] = useState(null);

    useEffect(() => {
        if (matchedProducts?.length) {
            setProducts(matchedProducts.map((item) => ({
                ...item
            })));
            return;
        }
        const getEnv = () => {

            const {phpEnvName} = TVSite;
            let env = null;
            if (phpEnvName) {
                if (phpEnvName === "local") {
                    env = "test";
                } else {
                    env = phpEnvName;
                }
            }
            if (env) {
                const isProduction = (env === "prod" || env === "app");
                return isProduction ? "app" : env;
            }
            return "app";

        }
        const productUrl = `https://${getEnv()}.creatable.io/v2/api/entity/${clientId}/entity/${entityId}/products`;
        axios.get(productUrl).then(response => {
            setProducts(response.data.matches.map((item) => {
                return {...item.entity, ...item.entity.data, product_id: item.product_id}
            }));

        });
    }, [entityId, matchedProducts, clientId]);


    const currencySymbol = ClientConfigurationHelper.getSection('experiences')?.currency_symbol || "$";

    const resizeHandler = useCallback(() => {

        const productTitleBox = document.querySelector('[data-testid="products-container"] .swiper-slide-active .carousel-product-title');
        const productPriceBox = document.querySelector('[data-testid="products-container"] .swiper-slide-active .carousel-product-price');
        const productImageBox = document.querySelector('[data-testid="products-container"] .swiper-slide-active .carousel-product-image');
        if (productImageBox && productPriceBox && productTitleBox) {
            const haltImageSize = (productImageBox.clientHeight / 2) + 12
            setHeight((haltImageSize + productTitleBox.clientHeight + productPriceBox.clientHeight) + "px");
        }

    }, [height, setHeight])

    const arrowL = useRef(null);
    const arrowR = useRef(null);
    const classes = useStyles();

    const handleOpen = () => {
        setIsDetailsOpen(true);
        setTimeout(() => {
            //alert('swiper resize');
            swiperInstance?.update();
            swiperInstance?.updateSize();
            resizeHandler();

        }, 500)
    }
    const handleClose = () => {
        setIsDetailsOpen(false);
    }
    const productHide = (e) => {
        const isOpenButton = e.target.classList.contains(classes.mainWrapper);
        if (isDetailsOpen && isOpenButton) {
            handleClose();
        }
    }


    return <Box height={{xs: '100%', sm: '100%'}}
                className={classes.mainWrapper}
                data-testId={"products-container"}
                onClick={productHide}>
        {(products.length > 0) &&
            <MiniProduct currencySymbol={currencySymbol} onClick={handleOpen} className={classes.miniCard}
                         product={products[0]}/>}

            <Box bgcolor={'#ffffff'} zIndex={'1200'} sx={{'& .swiper-slide':{height: '100%'}}} height={'100%'}
                 className={classes.fullCard + " " + (isDetailsOpen ? classes.openDetails : "")}>
                <div className={classes.shapeMobile}>
                    <div onClick={handleClose}>
                        <Box p={"3px"}></Box>
                    </div>
                </div>
                <Box position={'relative'} maxWidth={{xs: '100vw', sm: '100%'}} height={'100%'}>
                <Swiper
                    observer={true}
                    onInit={(swiper) => {
                        setSwiperInstance(swiper);
                    }}
                    data-testId={"products-swiper"}
                    centerInsufficientSlides={true}
                    navigation={{
                        enabled: true,
                        nextEl: arrowR.current,
                        prevEl: arrowL.current,
                    }}
                    modules={[Navigation]}
                    style={{
                        height: '100%',
                        '--swiper-navigation-top-offset': height,
                        '--swiper-navigation-sides-offset': '55px'
                    }}
                    onUpdate={( swiper) => {
                        resizeHandler();
                    }}
                    slidesPerView={1}>
                    {

                        products.map((item, index) => {
                            return <SwiperSlide key={item.id}> <ProductItem currencySymbol={currencySymbol}
                                                                            onClick={handleClose} index={index + 1}
                                                                            total={products.length}
                                                                            entityId={entityId}
                                                                            userId={userId}
                                                                            item={item}/></SwiperSlide>
                        })
                    }
                    <div ref={arrowL} className={'swiper-button-prev ' + classes.arrows}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path
                                d="M15.674 6.70498C15.284 6.31498 14.654 6.31498 14.264 6.70498L9.67401 11.295C9.28401 11.685 9.28401 12.315 9.67401 12.705L14.264 17.295C14.654 17.685 15.284 17.685 15.674 17.295C16.064 16.905 16.064 16.275 15.674 15.885L11.794 11.995L15.674 8.11498C16.064 7.72498 16.054 7.08498 15.674 6.70498Z"
                                fill="#49454F"/>
                        </svg>
                    </div>
                    <div ref={arrowR} className={'swiper-button-next ' + classes.arrows}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path
                                d="M9.32598 6.71063C8.93598 7.10063 8.93598 7.73063 9.32598 8.12063L13.206 12.0006L9.32598 15.8806C8.93598 16.2706 8.93598 16.9006 9.32598 17.2906C9.71598 17.6806 10.346 17.6806 10.736 17.2906L15.326 12.7006C15.716 12.3106 15.716 11.6806 15.326 11.2906L10.736 6.70063C10.356 6.32063 9.71598 6.32063 9.32598 6.71063Z"
                                fill="#49454F"/>
                        </svg>
                    </div>
                </Swiper>
                </Box>
            </Box>
    </Box>
}
export default Products;
